(() => {
  'use strict';
  const blockedPath = /(?:^|\/)(?:cart|checkout|checkouts)(?:\/|$)/i;
  function blocked(value) {
    if (!value) return false;
    try {
      const url = new URL(value, location.href);
      const internal = url.origin === location.origin || /(?:^|\.)myshopify\.com$/i.test(url.hostname) || url.hostname === 'checkout.shopify.com';
      return internal && blockedPath.test(decodeURIComponent(url.pathname));
    } catch { return false; }
  }
  document.addEventListener('click', (event) => {
    const anchor = event.target.closest?.('a[href]');
    if (anchor && blocked(anchor.getAttribute('href'))) {
      event.preventDefault();
      event.stopImmediatePropagation();
      location.assign(document.body.dataset.catalogUrl || `${document.body.dataset.rootUrl || '/'}collections/all`);
    }
  }, true);
  document.addEventListener('submit', (event) => {
    const submitAction = event.submitter?.getAttribute('formaction');
    if (blocked(submitAction || event.target.getAttribute('action'))) {
      event.preventDefault();
      event.stopImmediatePropagation();
      location.assign(document.body.dataset.catalogUrl || `${document.body.dataset.rootUrl || '/'}collections/all`);
    }
  }, true);
  if (blocked(location.href)) location.replace(document.body.dataset.catalogUrl || `${document.body.dataset.rootUrl || '/'}collections/all`);
})();
